import { __assign } from "tslib";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { isValidElement, useRef } from 'react';
import { getGlobalObject } from '../utils/getGlobalObject';
function isClassComponent(component) {
    var _a;
    return (typeof component === 'function' && !!((_a = component.prototype) === null || _a === void 0 ? void 0 : _a.isReactComponent));
}
function isFunctionComponent(component) {
    return (typeof component === 'function' &&
        component.hasOwnProperty('props') &&
        isValidElement(component));
}
function isReactRouterComponent(component) {
    return isClassComponent(component) || isFunctionComponent(component);
}
export var withRum = function (component) {
    return function RumView(props) {
        useRef((function () {
            var _a, _b, _c;
            if (!component) {
                return;
            }
            var globalObj = getGlobalObject();
            if (!globalObj.DD_RUM) {
                console.warn('@datadog/rum-react-integration: Datadog RUM SDK is not initialized.');
                return;
            }
            if (!((_a = globalObj.DD_RUM) === null || _a === void 0 ? void 0 : _a.startView)) {
                console.warn('@datadog/rum-react-integration: Manual tracking not supported. Try updating the Datadog RUM SDK.');
                return;
            }
            var manualTracking = !!((_c = (_b = globalObj.DD_RUM) === null || _b === void 0 ? void 0 : _b.getInitConfiguration()) === null || _c === void 0 ? void 0 : _c.trackViewsManually);
            if (!manualTracking) {
                console.warn('@datadog/rum-react-integration: The trackViewsManually flag in RUM initialization must be set to %ctrue%c.', 'color:green', 'color:default');
                return;
            }
            globalObj.DD_RUM.startView(props.match.path);
        })());
        if (!component) {
            return _jsx(_Fragment, { children: component }, void 0);
        }
        else if (isReactRouterComponent(component)) {
            var Component = component;
            return _jsx(Component, __assign({}, props), void 0);
        }
        else if (component instanceof Function) {
            return _jsx(_Fragment, { children: component(props) }, void 0);
        }
        return _jsx(_Fragment, { children: component }, void 0);
    };
};
//# sourceMappingURL=RumRouteComponentWrapper.js.map